// angular
import {Component, inject} from "@angular/core";
import {RouterLink} from "@angular/router";
// material angular
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
// services
import {UserService} from "@app/shared/services/user.service";
import {FirebaseService} from "@app/+messaging/shared/services/firebase.service";
import {AuthService} from "@app/+authentication/shared/services/auth.service";

@Component({
  selector: "app-profile-menu",
  templateUrl: "./profile-menu.component.html",
  styleUrls: ["./profile-menu.component.scss"],
  standalone: true,
  imports: [MatIconModule, MatMenuModule, RouterLink],
})
export class ProfileMenuComponent {
  // dependencies
  private _userService = inject(UserService);
  private _authService = inject(AuthService);
  private _firebaseService = inject(FirebaseService);

  constructor() {}

  public logout() {
    this._authService.logout().subscribe({
      next: () => {
        this._firebaseService.removeFirebase();
        this._userService.logout();
      },
      error: (err) => {
        console.log(err);
        this._firebaseService.removeFirebase();
        this._userService.logout();
      },
    });
  }
}
